import { render, staticRenderFns } from "./OrdersInfoModal.vue?vue&type=template&id=1f256b60&scoped=true&"
import script from "./OrdersInfoModal.vue?vue&type=script&lang=js&"
export * from "./OrdersInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f256b60",
  null
  
)

export default component.exports